import { formatDistanceToNow, format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

export const formatTimeAgo = (date: string): string => {
  console.log(date);
  try {
    return formatDistanceToNow(new Date(date), { addSuffix: true, locale: es });
  } catch (error) {
    return '';
  }
};

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const formatDate = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "d 'de' MMM. 'de' yyyy", { locale: es });
};

export const formatDateExpres = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "d MMM yyyy", { locale: es });
};

export const formatLocalDate = (date: string) => {
  if (!date) return;
  let dateISO = date;
  // convert to utc date
  if (!date.endsWith("Z")) dateISO = `${dateISO}Z`;
  const dateUTC = new Date(dateISO);
  //convert to iso but the local date
  const year = dateUTC.getFullYear();
  const month = String(dateUTC.getMonth() + 1).padStart(2, '0');
  const day = String(dateUTC.getDate()).padStart(2, '0');
  const hours = String(dateUTC.getHours()).padStart(2, '0');
  const minutes = String(dateUTC.getMinutes()).padStart(2, '0');
  const seconds = String(dateUTC.getSeconds()).padStart(2, '0');
  const milliseconds = String(dateUTC.getMilliseconds()).padStart(6, '0');
  const newDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  return formatTimeAgo(newDate);
}